interface MetricCardProps {
  label: string;
  value: number;
  icon: React.ComponentType<any>;
  className?: string;
}

export function MetricCard({ label, value, icon: Icon, className }: MetricCardProps) {
  return (
    <div class={`bg-white rounded-lg p-4 shadow-sm border ${className || ''}`}>
      <div class="flex items-center justify-between">
        <div class="text-2xl font-bold text-gray-900">
          {value.toLocaleString()}
        </div>
        <Icon className="h-6 w-6 text-gray-500" />
      </div>
      
      <div class="text-sm text-gray-600 mt-1">
        {label}
      </div>
    </div>
  );
}
